export default __webpack_public_path__ + "static/media/phone.1187e03f.svg";